import Config from 'Config';
import aws4 from 'aws4';

/**
 * Used to set notes to the database
 * @param {array} notes array of note objects 
 * @param {array} noteIds array of note Ids 
 * @param {*} params 
 * @returns array of notes
 */
export default async function setFormNotes(notes, params) {
    const apiPath = `set-form-notes`;

    const request = {
        host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(notes),
    };
    const signer = new aws4.RequestSigner(request, {
        accessKeyId: params.accessKeyId,
        secretAccessKey: params.secretAccessKey,
        sessionToken: params.sessionToken,
    });
    const signedRequest = signer.sign();
    signedRequest.headers.Accept = '*/*';

    const response = await fetch(
        `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
        // `http://localhost:3001/${apiPath}`,
        signedRequest
    ).then((res) => res.json());
    return response;
}